define('plugin/location/model/LocationModel',['require','lib/model/BaseModel'],function (require) {
	
	var BaseModel = require('lib/model/BaseModel');
	
	/**
	 * Location info model
	 * 
	 * @class LocationModel
	 */
	return BaseModel.extend({
		
		defaults: {
			id: '',
			description: '',
			title: ''
		}
		
	});
	
});
